import React, { useState } from 'react';
import { Box, Typography, Paper, TextField, Button, Switch, FormControlLabel, Snackbar, Alert } from '@mui/material';
import { apiFetch } from '../utils/apiFetch';

export default function MoverSettings({ token }) {
  const [password, setPassword] = useState('');
  const [twoFA, setTwoFA] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const handleChangePassword = async () => {
    if (!password || password.length < 6) {
      setSnackbar({ open: true, message: 'Password must be at least 6 characters', severity: 'error' });
      return;
    }
    
    try {
      await apiFetch('/api/settings/password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ newPassword: password })
      });
      setSnackbar({ open: true, message: 'Password changed!', severity: 'success' });
      setPassword('');
    } catch {
      setSnackbar({ open: true, message: 'Failed to change password.', severity: 'error' });
    }
  };

  const handleToggle2FA = async (e) => {
    const enabled = e.target.checked;
    setTwoFA(enabled);
    try {
      await apiFetch('/api/settings/2fa', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ enabled })
      });
      setSnackbar({ open: true, message: `2FA ${enabled ? 'enabled' : 'disabled'}!`, severity: 'success' });
    } catch {
      setSnackbar({ open: true, message: 'Failed to toggle 2FA.', severity: 'error' });
      setTwoFA(!enabled); // Revert on error
    }
  };
  return (
    <Box sx={{ py: { xs: 1, md: 2 }, maxWidth: 900 }}>
      <Typography variant="overline" sx={{ color: '#008D7B', fontWeight: 800, letterSpacing: 1.1 }}>ACCOUNT</Typography>
      <Typography variant="h5" sx={{ color: '#173057', mb: .5, fontWeight: 800 }}>Settings</Typography>
      <Typography variant="body2" sx={{ color: '#60748D', mb: 3 }}>Manage sign-in and account security preferences.</Typography>
      <Paper elevation={0} sx={{ p: { xs: 2, md: 3 }, mb: 2, border: '1px solid #E4ECF2', borderRadius: 1 }}>
        <Typography variant="subtitle1" fontWeight={800} sx={{ color: '#173057', mb: 2 }}>Change password</Typography>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 1.5, mb: 2 }}>
          <TextField label="New Password" type="password" value={password} onChange={e => setPassword(e.target.value)} size="small" />
          <Button variant="contained" onClick={handleChangePassword}>Change</Button>
        </Box>
        <FormControlLabel control={<Switch checked={twoFA} onChange={handleToggle2FA} color="primary" />} label="Enable two-factor authentication" />
      </Paper>
      <Snackbar open={snackbar.open} autoHideDuration={2000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert severity={snackbar.severity} sx={{ width: '100%' }}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
}
